import { Theme } from "@mui/material";

import { DutyScheduleDisplayStatus } from "@/api";

type StatusLabelKey = "dutySchedule.status.inProgress" | "dutySchedule.status.released" | "dutySchedule.status.current";

export function getStatusLabelKey(status: DutyScheduleDisplayStatus): StatusLabelKey {
  switch (status) {
    case DutyScheduleDisplayStatus.Released:
      return "dutySchedule.status.released";
    case DutyScheduleDisplayStatus.Current:
      return "dutySchedule.status.current";
    default:
      return "dutySchedule.status.inProgress";
  }
}

export function getStatusColor(theme: Theme, status: DutyScheduleDisplayStatus): string {
  switch (status) {
    case DutyScheduleDisplayStatus.Released:
      return theme.palette.fsw.blue;
    case DutyScheduleDisplayStatus.Current:
      return theme.palette.fsw.green;
    default:
      return theme.palette.fsw["oragen-wcag"];
  }
}
